<template>
    <section class="modal-card-body">
        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <label class="label">Name</label>
                            <p class="control is-expanded ">
                                <input v-model="multiProforma.user_name" class="input" type="text"
                                       placeholder="Name" disabled>
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">Street</label>
                            <p class="control is-expanded ">
                                <input v-model="multiProforma.client_street" class="input" type="text"
                                       placeholder="Street">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">City</label>
                            <p class="control is-expanded ">
                                <input v-model="multiProforma.client_city" class="input" type="text"
                                       placeholder="City">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">Country</label>

                            <div class="select is-fullwidth">
                                <select v-model="multiProforma.client_country">
                                    <option value="" hidden disabled>Select Country</option>
                                    <option v-for="country in countries">{{ country.name }}</option>
                                </select>
                            </div>

                        </div>
                        <div class="field">
                            <label class="label">Phone</label>
                            <p class="control is-expanded ">
                                <input v-model="multiProforma.client_phone" class="input" type="text"
                                       placeholder="Phone">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">Email</label>
                            <p class="control is-expanded ">
                                <input v-model="multiProforma.client_email" class="input" type="text"
                                       placeholder="Email">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">Tax ID</label>
                            <p class="control is-expanded ">
                                <input v-model="multiProforma.client_tax_id" class="input" type="text"
                                       placeholder="Tax ID">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">RUC</label>
                            <p class="control is-expanded ">
                                <input v-model="multiProforma.client_ruc" class="input" type="text"
                                       placeholder="Tax ID">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <label class="label">Payment term</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                    <select v-model="multiProforma.payment_term">
                                        <option value="">Select Payment Term</option>
                                        <option v-for="payment_term in paymentTerms"
                                                :value="payment_term">{{ payment_term }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Incoterm</label>
                            <div class="control">
                                <div class="select is-fullwidth">
                                    <select v-model="multiProforma.incoterm">
                                        <option value="">Select Incoterm</option>
                                        <option v-for="incoterm in incoterms"
                                                :value="incoterm">{{ incoterm }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>


                            <div class="field">
                                <label class="label">Due date</label>
                                <p class="control is-expanded has-icons-left is-fullwidth">
                                    <datetime
                                            input-class="input"
                                            v-model="multiProforma.due_date"
                                            :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                            type="date"
                                            value-zone="local"
                                            zone="local"
                                            placeholder="Select Date"
                                    ></datetime>
                                    <span class="icon is-small is-left">
                                                      <i class="fas fa-calendar-alt"></i>
                                                    </span>
                                </p>
                            </div>

                            <div class="field">
                                <label class="label">Balance due date</label>
                                <div class="select is-fullwidth">
                                    <select v-model="balanceDate">
                                        <option value="">Select Date</option>
                                        <option v-for="balance_date in balanceDates"
                                                :value="balance_date">{{ balance_date }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="field" v-if="balanceDate == 'Custom'">
                                <label class="label">&nbsp;</label>
                                <p class="control is-expanded has-icons-left is-fullwidth">
                                    <datetime
                                            input-class="input"
                                            v-model="balanceDateCustom"
                                            :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                            type="date"
                                            value-zone="local"
                                            zone="local"
                                            placeholder="Select Balance Due Date"
                                    ></datetime>
                                    <span class="icon is-small is-left">
                                                      <i class="fas fa-calendar-alt"></i>
                                                    </span>
                                </p>
                            </div>


                    </div>
                </div>
            </div>
        </div>
        <div v-for="(group, index) in shipping_groups">
            <h5 style="margin: 10px 0"><b>Shipping Group: #{{ group.shipping_id }}</b></h5>
        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <label class="label">Carrier</label>
                            <p class="control is-expanded ">
                                <input v-model="group.carrier" class="input" type="text"
                                       placeholder="Carrier">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">Vessel</label>
                            <p class="control is-expanded ">
                                <input v-model="group.vessel" class="input" type="text"
                                       placeholder="Vessel">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">BL Number</label>
                            <p class="control is-expanded ">
                                <input v-model="group.bl_number" class="input" type="text"
                                       placeholder="Bl Number">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">POL</label>
                            <p class="control is-expanded ">
                                <input v-model="group.port_of_loading" class="input" type="text"
                                       placeholder="POL">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">POA</label>
                            <p class="control is-expanded ">
                                <input v-model="group.port_of_arrival" class="input" type="text"
                                       placeholder="POA">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">ETD</label>
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="group.estimated_departure"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select Date"
                                ></datetime>
                                <span class="icon is-small is-left">
                                                      <i class="fas fa-calendar-alt"></i>
                                                    </span>
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">ETA</label>
                            <p class="control is-expanded has-icons-left is-fullwidth">
                                <datetime
                                        input-class="input"
                                        v-model="group.estimated_arrival"
                                        :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                        type="date"
                                        value-zone="local"
                                        zone="local"
                                        placeholder="Select Date"
                                ></datetime>
                                <span class="icon is-small is-left">
                                                      <i class="fas fa-calendar-alt"></i>
                                                    </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <table class="table is-fullwidth is-bordered">
                    <thead>
                    <tr>
                        <th>Brand</th>
                        <th>Model</th>
                        <th>Year</th>
                        <th>Color</th>
                        <th>Chassis</th>
                        <th>Price</th>
                    </tr>
                    </thead>
                    <tbody>
                       <tr v-for="invoice in group.invoices">
                           <td>
                               <span>{{ invoice.brand }}</span>
                           </td>
                           <td>
                               <span>{{ invoice.model }}</span>
                           </td>
                           <td>
                               <span>{{ invoice.year }}</span>
                           </td>
                           <td>
                               <input class="input" v-model="invoice.color" />
                           </td>
                           <td>
                               <input class="input" v-model="invoice.chassis" />
                           </td>
                           <td>
                               <input class="input" v-model="invoice.price"/>
                           </td>
                       </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="4" style="text-align: right;">Grand Total</th>
                            <th>{{ getCurrentUserDepositRate }}{{ grandTotal(group.invoices) | formatNumber }}</th>
                        </tr>
                        <tr>
                            <th colspan="4" style="text-align: right;">First Payment</th>
                            <th>{{ getCurrentUserDepositRate }}{{ firstPayment(group.invoices) | formatNumber}}</th>
                        </tr>
                        <tr>
                            <th colspan="4" style="text-align: right;">Balance Due</th>
                            <th>{{ getCurrentUserDepositRate }}{{ balanceDue(group.invoices) | formatNumber }}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Datetime} from 'vue-datetime'
    export default {
        props: ['car'],
        components: {
            Datetime
        },
        data() {
            return {
                paymentTerms: ['100%', '50%-50%', '30%-70%'],
                balanceDates: ['1 Week', '2 Weeks', '3 Weeks', '1 Month', '2 Months', '3 Months', 'Custom'],
                incoterms: ['FOB', 'CIF', 'C&F'],
                countries: [],
                user_name: ''
            }
        },
        computed: {
            multiProforma() {
                return this.$store.getters.getMultiProformaFields
            },
            balanceDate: {
                get() {
                    let balanceDueDate = this.$store.getters.getMultiProformaFields.balance_due_date
                    return balanceDueDate.indexOf('Custom') > -1 ? 'Custom' : balanceDueDate
                },
                set(value){
                    this.multiProforma.balance_due_date = value
                }
            },
            balanceDateCustom: {
                get() {
                    let balanceDueDate = this.$store.getters.getMultiProformaFields.balance_due_date
                    return balanceDueDate.indexOf('Custom') > -1 ? balanceDueDate.replace('Custom ', '') : balanceDueDate
                },
                set(value){
                    this.multiProforma.balance_due_date = "Custom "+value
                }
            },
            shipping_groups: {
                get() {
                    return this.$store.getters.getMultiProformaFields.shipping_groups
                },
                set(value){

                }
            },
            getCurrentUserDepositRate() {
                return this.$store.getters.getMultiProformaFields.currency == 'JPY' ? '¥' : '$'
            }
        },
        methods: {
            grandTotal(invoices){
                let grandTotal = 0;
                for(let i=0;i<invoices.length;i++){
                    grandTotal += Number(invoices[i].price);
                }

                return grandTotal;
            },
            firstPayment(invoices){
                let grandTotal = 0;
                for(let i=0;i<invoices.length;i++){
                    grandTotal += Number(invoices[i].price);
                }
                let deposit_p = 0;
                const paymentTerm = this.multiProforma.payment_term.split('-');
                if(paymentTerm){
                    deposit_p = paymentTerm[0].replace('%', '');
                }
                return grandTotal * deposit_p/100
            },
            balanceDue(invoices){
                let grandTotal = 0;
                for(let i=0;i<invoices.length;i++){
                    grandTotal += Number(invoices[i].price);
                }
                let deposit_p = 0;
                const paymentTerm = this.multiProforma.payment_term.split('-');
                if(paymentTerm){
                    deposit_p = paymentTerm[0].replace('%', '');
                }
                const firstPayment = grandTotal * deposit_p/100
                return grandTotal - firstPayment
            }
        },
        mounted() {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
            .then((response) => {
                this.countries = response.data
            })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Users/User/Tabs/MultiProformaModal/MultiProformaInvoiceBody.vue